'use client';

import { cn } from '@core/utils';
import { motion } from 'framer-motion';

import { PrizeCardContent } from './CardContent';

type PrizeCardAnimatedProps = {
  regions: 2 | 5 | 7 | 10;
  isCompleted?: boolean;
};

export const PrizeCardAnimated = ({
  regions,
  isCompleted = false,
}: PrizeCardAnimatedProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1],
      }}
      className={cn(
        'relative overflow-hidden rounded-medium',
        isCompleted
          ? 'bg-gradient-to-r from-O-400 to-[#ff4800] shadow-[-1px_7px_12px_0px_#ffcda1]'
          : 'bg-Gray-white',
      )}
      role="listitem"
      aria-label={`${regions}곳 기부 경품${isCompleted ? ', 완료됨' : ''}`}
    >
      <PrizeCardContent regions={regions} isCompleted={isCompleted} />
    </motion.div>
  );
};
